import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import Menu from "material-ui-next/Menu";
import MenuItem from "material-ui-next/Menu/MenuItem";
import Icon from "material-ui-next/Icon";

import {
  CheckBox,
  DataTable,
  If,
  Loadable,
  TextToMask,
  Page,
  StyledButton,
  Link
} from "components/support";

import style from "./style";
import { colors } from "assets";
import Filter from "./filter";

class SupportCompanyView extends Component {
  config = {
    identifier: "id",
    columns: [
      {
        accessor: "id",
        show: false
      },
      {
        id: "checkboxes",
        Header: () => (
          <CheckBox
            checked={this.allCheckBoxesSelected()}
            onCheck={checked => this.selectAllCheckBoxes(checked)}
            style={{ padding: 0, margin: "0px 0px 0px 5px" }}
            squareIconStyle={{
              backgroundColor: "#FFFFFF",
              margin: "2px 1.5px 2px 2px"
            }}
            checkBoxStyle={{ border: "2px solid #FFFFFF" }}
          />
        ),
        Cell: props => (
          <CheckBox
            checked={this.props.viewModel.checkedRows[props.original.uuid]}
            onCheck={checked =>
              this.props.presenter.onSingleCheckBoxEnqueue({
                [props.original.uuid]: checked
              })
            }
            style={{ padding: 0, margin: "0px 0px 0px 9px" }}
            checkBoxStyle={{ border: `1px solid ${colors.primary.normal}` }}
          />
        ),
        align: "center",
        sortable: false,
        width: 50
      },
      {
        id: "name",
        accessor: "name",
        Header: "Nome Fantasia",
        Cell: props => (
          <div>
            <Link
              onClick={() =>
                this.props.presenter.companyDetails(props.original.uuid)
              }
              label={props.original.name}
            />
          </div>
        )
      },
      {
        id: "fiscal_informations.cnpj",
        Header: "CNPJ",
        align: "center",
        Cell: props => this.parseCnpj(props)
      },
      {
        id: "plan",
        accessor: "plan_uuid",
        Header: "Plano",
        align: "center",
        sortable: false,
        Cell: props => this.parsePlanName(props)
      },
      {
        id: "blocked",
        accessor: "blocked",
        Header: "Status",
        align: "center",
        sortable: false,
        Cell: props => this.parseBlocked(props.original.blocked)
      }
    ]
  };

  allCheckBoxesSelected = () => {
    const { checkedRows, companies } = this.props.viewModel;
    for (const c of companies) {
      if (!checkedRows[c.uuid]) {
        return false;
      }
    }
    return true;
  };

  selectAllCheckBoxes = checked => {
    const { companies } = this.props.viewModel;
    let checkedRows = {};
    checkedRows = companies.reduce(
      (acc, c) => ({ ...acc, [c.uuid]: checked }),
      {}
    );
    if (!checked) {
      checkedRows = {};
    }
    this.props.presenter.onCheckBoxEnqueue(checkedRows);
  };

  parseCnpj(props) {
    const hasFiscalInformations = !!props.original.fiscal_informations;
    const hasCnpj =
      !!hasFiscalInformations && !!props.original.fiscal_informations.cnpj;
    const value = !!hasCnpj ? props.original.fiscal_informations.cnpj : "";
    return <TextToMask value={value} mask="cnpj" />;
  }

  parsePlanName(props) {
    const plans = this.props.viewModel.plans;
    const plan_uuid = props.original.plan_uuid;
    const plan = plans.find(p => p.uuid === plan_uuid);
    const planName = plan ? plan.name : "-";
    return <div>{planName}</div>;
  }

  parseBlocked(blocked) {
    return (
      <div className={this.props.className}>
        <If test={blocked}>
          <Typography type="body2" className="blocked-text">
            BLOQUEADO
          </Typography>
        </If>
        <If test={!blocked}>
          <Typography type="body2" className="active-text">
            ATIVO
          </Typography>
        </If>
      </div>
    );
  }

  render() {
    const { className, viewModel, presenter } = this.props;
    const {
      companies,
      pagination,
      order,
      loading,
      anchor,
      plans,
      renderButton
    } = viewModel;

    return (
      <Loadable loading={loading}>
        <Page className={className}>
          <Typography type="display1" className="pb-sm">
            Empresas
          </Typography>
          <Row>
            <Col xs={12}>
              <Filter
                plans={plans}
                onFilter={fields => presenter.onFilterChange(fields)}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={6}>
              <If test={renderButton}>
                <StyledButton
                  style={{ margin: 0, backgroundColor: colors.primary.dark }}
                  primary
                  onClick={event => presenter.handleMenuOpen(event)}
                >
                  <Row middle="xs">
                    <Col xs={8} className="pr-0">
                      Ações
                    </Col>
                    <Col xs={4} className="pr-0">
                      <Icon style={{ fontSize: 20, marginTop: 4 }}>
                        keyboard_arrow_down
                      </Icon>
                    </Col>
                  </Row>
                </StyledButton>
              </If>

              <Menu
                id="company-block-menu"
                anchorEl={anchor}
                open={Boolean(anchor)}
                onClose={() => presenter.handleMenuClose()}
              >
                <MenuItem onClick={() => presenter.handleMenuClick(true)}>
                  Bloquear
                </MenuItem>
                <MenuItem onClick={() => presenter.handleMenuClick(false)}>
                  Desbloquear
                </MenuItem>
              </Menu>
            </Col>

            <Col className="company__content text-right company_qtd" xs={6}>
              <h3 style={{ textAlign: "right", padding: 10, margin: 0 }}>
                {pagination.total} empresa(s) encontrada(s)
              </h3>
            </Col>

            <Col xs={12}>
              <Paper elevation={1} className="user__content">
                <DataTable
                  manual
                  filterable={false}
                  resultSet={companies}
                  total={pagination.total}
                  perPage={pagination.perPage}
                  page={pagination.currentPage}
                  config={this.config}
                  orderField={order.field}
                  orderDirection={order.direction}
                  ignoreLinkFields={["checkboxes"]}
                  linkRow={true}
                  onClickRow={uuid => presenter.companyDetails(uuid)}
                  onPageChange={page => presenter.onPageChange(page + 1)}
                  onChange={({ field, value }) =>
                    presenter.onOrderChange(field, value)
                  }
                />
              </Paper>
            </Col>
          </Row>
        </Page>
      </Loadable>
    );
  }
}

export default style(SupportCompanyView);



// WEBPACK FOOTER //
// ./src/components/app/support/company/view.jsx